module.exports = __webpack_public_path__ + "img/home_img_emptycar@2x.55f2d986.png";